import moment from 'moment-timezone';
import { getTimeZone, getFormatDate } from 'utils/timeZone';
import {formatDate} from './formatting_utils';
import { formatDateToISO } from 'utils/date_utils_new';

export default class DateUtils {
	static regexDateISOGlobal = new RegExp(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(([+-]\d+(:\d+)?)|[zZ])?/g);
	static regexISO2 = new RegExp(/\d{4}(-)(((0)[0-9])|((1)[0-2]))(-)([0-2][0-9]|(3)[0-1])(\s)(2[0-3]|[01][0-9])?(:(\d+))?(:(\d+))?(.(\d+))?/g);

	static convertDateStringToISOString(value) {
		return this.isISO8601Date(value)
		? value
		: formatDateToISO(value)
	}

	static convertDateStringToMoment(value, format = 'date') {		
		return moment.tz(this._parseValue(value), getFormatDate(this._parseValue(value)), getTimeZone()).utc()
	}

	static convertDateStringToMomentGlobal(value) {
		const dates = value.match(this.regexDateISOGlobal) || value.match(this.regexISO2) || [];
		return dates.reduce((v, dateISO) => v.replace(dateISO, formatDate(dateISO)), value);
	}

	static isISO8601DateGlobal(value) {
		return value != undefined && (this.regexDateISOGlobal.test(value) || this.regexISO2.test(value));
	}

	static isISO8601Date(value) {
		const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(([+-]\d+(:\d+)?)|[zZ])?$/i;
		return regex.test(value);
	}

	static _parseValue(value) {
		const isNumeric = new RegExp(/^\d+$/);
		return isNumeric.test(value) ? new Date(parseInt(value)) : value;
	}

	static _isStripedDate(value) {
		const regex = /^\d{4}-\d{2}-\d{2}$/;
		return regex.test(value);
	}
}
